import Header from '../components/header-menu'
import HeaderPWA from '../components/header'
import Layout from '../components/layout-alpha'
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import Container from '../components/container'
import BlocReferences from '../components/bloc-references'
import FormBottom from '../components/form-bottom'
import ErrorPage  from 'next/error'
import {websiteUrl, website} from '../lib/utils';
import {getAllMarques, getPostAndMorePosts} from "../lib/api";


export default function Index({ preview, allPosts, allExemples, siteEnv, marques }) {
  const website_url =
    siteEnv == 'pwafr'
      ? 'https://www.progressive-web-apps.fr/'
      : websiteUrl(siteEnv);
  if(siteEnv != "alphalives"){
    return (<ErrorPage statusCode={404} />)
  }
  return (
    <>
      <Layout preview={preview} siteEnv={siteEnv}>
        <Head>
          <title>Alphalives : Nos références</title>
          <meta name="description" content="Alphalives, agence spécialisée dans le développement sur mesure. Logiciels métiers sur mesure, Sites internet, Application mobiles, Newsletters, Landing pages" />
          <link href="https://www.alphalives.com/references" rel="canonical"/>
        </Head>
        <div>
          {siteEnv == 'alphalives' && <Header />}
          {siteEnv == 'pwafr' && <HeaderPWA />}
          <div id="references">
             <img className="pic-ref_1"  src="/img/whiteband.png" alt="Picture of the author" />
            <img className="pic-ref_2"  src="/img/orange-top-band.png" alt="Picture of the author" /> 
            <div className="site-wrapper-inner">
              <Container>
                <h1 className="text-center">Nos Références</h1>
                <div className="wrapper-text text-center">
                 <p className="text-for-references">
                     De nombreuses entreprises reconnues ont fait confiance à Alphalives pour la réalisation de différents travaux. L’agence web a réalisé des ouvrages divers et variés, mais toujours dans l’esprit de répondre à une demande spécifique avec une offre personnalisée. L’agence digitale a pu faire la refonte ou produire des sites internet sur mesure, concevoir des applications mobiles android ou IOS mais aussi des outils métiers et logiciels SAAS.
                 </p>
               

                </div>
                <div className="grid grid-cols-2">
                  <BlocReferences marques={marques} ></BlocReferences>
                </div>
              </Container>
            </div>
          </div>

          <FormBottom></FormBottom>
        </div>
      </Layout>
    </>
  )
}

export async function getStaticProps({ preview = false }) {
  const siteEnv = process.env.CONTENTFUL_SITE_TAG ?? 'pwafr';
  const marques = (await getAllMarques(preview)) ?? [];
  return {
    props: {
      preview,
      siteEnv,
      marques
    }
  }
}
